export const getIosVersion = async (): Promise<null | string> => null;
